import { CalendarCheck, Clock, ArrowRight } from "lucide-react";

export const BOOKING_URL = "https://turnos-online-1.emergent.host";

const OPTIONS = [
  ["1 hora", "Información", "booking-option-info"],
  ["2 horas", "Puesta en marcha", "booking-option-setup"],
  ["3 horas", "Estudio con formación al personal o formación a farmacéuticos", "booking-option-training"],
];

export const BookingBanner = () => (
  <div className="booking-glow relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-600 via-emerald-500 to-teal-500 text-white p-5 mb-6 shadow-xl" data-testid="login-booking-banner">
    <span className="booking-shine pointer-events-none absolute inset-y-0 -left-1/2 w-1/2" aria-hidden="true" />
    <span className="booking-sparkle absolute top-3 right-6 h-2 w-2 rounded-full bg-white" aria-hidden="true" />
    <span className="booking-sparkle absolute bottom-6 right-16 h-1.5 w-1.5 rounded-full bg-white [animation-delay:0.8s]" aria-hidden="true" />
    <span className="booking-sparkle absolute top-10 left-1/2 h-1 w-1 rounded-full bg-white [animation-delay:1.6s]" aria-hidden="true" />
    <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="relative flex items-center gap-3 group" data-testid="booking-main-link">
      <CalendarCheck className="h-9 w-9 shrink-0 animate-bounce" strokeWidth={2} />
      <span className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-none">RESERVA CITA</span>
      <ArrowRight className="h-6 w-6 ml-auto transition-transform group-hover:translate-x-1" strokeWidth={2.6} />
    </a>
    <div className="relative mt-4 grid gap-2">
      {OPTIONS.map(([hours, label, testId]) => (
        <a key={testId} href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
          className="flex items-center gap-3 rounded-lg bg-white/15 hover:bg-white/25 border border-white/25 px-3 py-2 transition-colors">
          <span className="inline-flex items-center gap-1 shrink-0 rounded-md bg-white text-emerald-700 text-xs font-extrabold px-2 py-1">
            <Clock className="h-3.5 w-3.5" /> {hours}
          </span>
          <span className="text-sm font-semibold leading-snug">{label}</span>
        </a>
      ))}
    </div>
  </div>
);
